import { useMutation } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { ValidationErrorResponse } from "../response/ValidationErrorResponse";
import { UpdateRolesFormData } from "../schema/UpdateRolesSchema";
import { UpdateRoleResponse } from "../response/UpdateRoleResponse";

export const useUpdateRole = () => {
    return useMutation({
        mutationFn: async (values: {
            roleId: number;
            formData: UpdateRolesFormData;
        }) => privateApi.put(`/v4/role/${values.roleId}`, values.formData),
        onSuccess: async (response) => {
            try {
                const validationResult = UpdateRoleResponse.safeParse(response.data);

                if (!validationResult.success) {
                    console.error("Validation failed:", validationResult.error.errors);
                    throw new Error("Invalid role data format");
                }

                return validationResult.data;
            } catch (error) {
                console.error('Failed to update role', error);
                throw error;
            }
        },
        onError: (error) => {
            const validationResult = ValidationErrorResponse.safeParse((error as any).response.data);

            if (!validationResult.success) {
                console.error("Validation failed:", validationResult.error.errors);
                throw new Error("Invalid role data format");
            } else {
                console.error('Failed to update role', error);
                throw error;
            }
        },
    });
};